 $('.own_wrist_size').rangeslider({
      polyfill: false,
        // Default CSS classes
        rangeClass: 'rangeslider',
        disabledClass: 'rangeslider--disabled',
        horizontalClass: 'rangeslider--horizontal',
        fillClass: 'rangeslider__fill',
        handleClass: 'rangeslider__handle',
        // Callback function
        onInit: function() {
          $('#own-page-wrist-size .step_value').html(this.value+"<span>cm</span>");
        },

        // Callback function
        onSlide: function(position, value) {
          $('#own-page-wrist-size .step_value').html(this.value+"<span>cm</span>");
        },
        // Callback function
      onSlideEnd: function(position, value) {}
    });
    $('.own_wrist_size').val(17).change();
    
    $('#own-page-wrist-size .next_step').click(function() {
        $('#own-page-wrist-size').fadeOut(500);
        $('#own-page-bead-size').fadeIn(100); 

            /*if($('.bead_input[name="bead"]:checked').val() == '6mm'){
              $('#sig').each(function(){
                 $('#sig').addClass('not-up');
              });
              
            }*/
          
    });
  
    // Global Var 
    var objBracelet = {};
    var stones_added = [];
    var tot_price = 0;
    var j;

    function currency(price) {
      var amount = parseFloat(price).toFixed(2);
      return '$'+amount;
    }
  
    $('#own-page-bead-size .next_step').click(function() {
    $('#own-page-bead-size').fadeOut(500);
        $('#own-page-stone-choice').fadeIn(100);

        for (j = 0; j < 24; j++) {
          objBracelet[j] = { 'id': j, variant: '', rarity: '', 'price': 0, 'title': '', 'img': ''};

        }
      
      calcStone();
    });
  
    $('#own-page-bead-size .prev_step').click(function() {
    $('#own-page-bead-size').fadeOut(500);
        $('#own-page-wrist-size').fadeIn(100);
    });
    
    $('#own-page-stone-choice .prev_step').click(function() {
    $('#own-page-stone-choice').fadeOut(500);
        $('#own-page-bead-size').fadeIn(100);
    });
  
    $( ".stone_select_right .stone,.stone_select_left .charms" ).draggable({ 
      containment: 'document',
      revert: 'valid',
      zIndex: 100,
      opacity: 0.6,
      delay: 300,
      appendTo: 'body',
      start: function( event, ui ) {},
      stop: function () {}
    });
  
    $('.stone_drop_center .stone_drop_area').sortable({
    opacity: 0.6,
    appendTo: 'body',
    helper: 'original',
    delay: 300,
    disabled: false, 
    activate: function(event, ui) {},
    start: function(event, ui) {},
    stop: function(event, ui) {},
        update: function(event, ui) {},   
    deactivate: function(event, ui) {}
  });
    
    $( ".stone_drop_area .stone_area" ).droppable({
        accept: '.stone,.charms',
    tolerance: 'intersect',
    activeClass: 'drag-active',
        hoverClass: 'drag-hover',
    over: function(event, ui) {},
    out: function(event, ui) {},
    drop: function( event, ui ) {
          var img_link = $(ui.draggable).attr('data-img');
          var title = $(ui.draggable).attr('data-title');
          var price = $(ui.draggable).attr('data-price');
          var variant = $(ui.draggable).attr('data-variant');
          var rarity = $(ui.draggable).attr('data-rarity');
            var j = parseInt($(this).attr('data-base'));
            $(this).addClass('stone_droped').css('background','url(' + img_link + ') no-repeat center center').attr('data-title',title).attr('data-price',price);
            objBracelet[j] = { 'id': j, variant: variant, rarity: rarity, 'price': price, 'title': title, 'img': img_link};
            refreshObjBracelet();
            calcStone();
    }
    });
  
    function empty_cart_details() {
        $('.details_added_cart').html('');
        $(".own_total_price .money").html(currency(129));
    }
  
    function refreshObjBracelet() {
      $('.stone_drop_area .stone_area').each(function(index) {
          var j = parseInt($(this).attr('data-base'));
          objBracelet[j].id = index;
      });
  }

    function calcStone() {
      
      empty_cart_details();

      var base_price = 0;
      
      var tot_price1 = 0;
      var strhtml = '';
      var num = 0;
      $('.stone_drop_area .stone_area').each(function(index) {
          var j = parseInt($(this).attr('data-base'));
          if ((objBracelet[j].price != '') || (objBracelet[j].title != '')) {
              strhtml = '<div class="details_added_cart_item" data-base="' + (index+1) + '" data-var="'+ objBracelet[j].variant +'">';
              strhtml += '<div class="cart_item_img"><img src=" ' + objBracelet[j].img + '"></div>';
              strhtml += '<div class="cart_item_desc">';
              strhtml += '<h4>'+ objBracelet[j].title +'</h4>';
              strhtml += '<span class="item_position">Position: '+ (index+1) +'</span>';
              strhtml += '<span class="item_price">'+ currency(objBracelet[j].price) +'</span>';
              strhtml += '</div>';
              strhtml += '<i class="fa fa-window-close removecart" aria-hidden="true" data-base="'+ j +'"></i></div>';
              $('.details_added_cart').append(strhtml);
 
              //tot_price += parseFloat(objBracelet[j].price);
              
              var beadSize = $('.bead_input[name="bead"]:checked').val();

              if(objBracelet[j].variant == '7626821173359' || objBracelet[j].variant == '7626821173362' || objBracelet[j].variant == '7626821173365' || objBracelet[j].variant == '7626821173368' || objBracelet[j].variant == '7626821173371' || objBracelet[j].variant == '7626821173362' || objBracelet[j].variant == '7626821173362' || objBracelet[j].variant == '7626821173374' || objBracelet[j].variant == '7626821173377' || objBracelet[j].variant == '7626821173380' || objBracelet[j].variant == '7626821173383' || objBracelet[j].variant == '7626821173403'){
                 if(objBracelet[j].variant == '7626821173380'){

                    if(beadSize == '8mm')
                      tot_price1 += parseFloat(60);
                    if(beadSize == '10mm')
                      tot_price1 += parseFloat(66);
                 }
                 else
                 tot_price1 += parseFloat(objBracelet[j].price);
              }
             
              
              
            // Rarity 1 
            if(objBracelet[j].rarity == '1'){
               if(!stones_added.includes("1")){
                    if(beadSize == '6mm')
                      tot_price = 39;
                    if(beadSize == '8mm')
                      tot_price = 49;
                    if(beadSize == '10mm')
                      tot_price = 59;
               }
            }
            
             
            // Rarity 2  
            if(objBracelet[j].rarity == '2'){
              if(!stones_added.includes("2")){
                        if(beadSize == '6mm')
                          tot_price = 49;
                        if(beadSize == '8mm')
                          tot_price = 59;
                        if(beadSize == '10mm')
                          tot_price = 69;
              }
            }
             
           // Rarity 3
           if(objBracelet[j].rarity == '3'){
              if(!stones_added.includes("3")){
                        if(beadSize == '6mm')
                          tot_price = 69;
                        if(beadSize == '8mm')
                          tot_price = 79;
                        if(beadSize == '10mm')
                          tot_price = 89;
              }
            }

            // Rarity 4
            if(objBracelet[j].rarity == '4'){
              if(!stones_added.includes("4")){
                        if(beadSize == '6mm')
                          tot_price = 79;
                        if(beadSize == '8mm')
                          tot_price = 99;
                        if(beadSize == '10mm')
                          tot_price = 129;
              }
            }
            
             stones_added[j] = objBracelet[j].rarity;
             

          }

      });
      
      $('.removecart').on('click', function () {
          var id = $(this);
          removeCartDetails(id, false);
      });
      
      var total_price = base_price + tot_price + tot_price1;
      var display_price = currency(total_price);
      $(".own_total_price .money").html(display_price);

      $('.details_added_cart .details_added_cart_item').each(function(index) {
          num += (index+1);
          if(num === 300) {
            $('.own_add_to_cart').prop("disabled", false);
          } else {
            $('.own_add_to_cart').prop("disabled", true);
          }
      });
            
      $('.own_add_to_cart').on('click', function () {
          $('.own_add_to_cart').prop("disabled", true).html('add to cart <i class="fa fa-spinner fa-spin"></i>');
          CartJS.clear(); // First Clear All Cart
        
          if(num === 300) {
            $('.details_added_cart .details_added_cart_item').each(function(index) {
              var variant = $(this).attr('data-var');
              var position = $(this).attr('data-base');
              CartJS.addItem(variant, 1, { "Position": position }, {
                // Define a success callback to display a success message.
                "success": function(data, textStatus, jqXHR) {
                    console.log(data,textStatus,jqXHR);
                },

                // Define an error callback to display an error message.
                "error": function(jqXHR, textStatus, errorThrown) {
                    console.log(jqXHR,textStatus,errorThrown)
                }
              });
            });
            var wrist = $('#own_wrist_size_range').val();
            var bead = $('.bead_input[name="bead"]:checked').val();
            CartJS.addItem(7670678716475, 1, {"Wrist Size": wrist+"cm", "Bead Size": bead}); // Stone
          }
        });
      
        $(document).on('cart.requestComplete', function(event, cart) {
          // If the queue is empty, we will redirect to the cart page.
          document.location.href = '/cart';
        });
    }
  
    $('.own_cart_added_details').click(function() {
        if ($('.details_added_cart').hasClass('none')) {
          open_cart_details();
        } else {
          close_cart_details();         
        }
    });
    
    function close_cart_details() {
    $('.details_added_cart').fadeOut(200);
        $('.details_added_cart').addClass('none');
        console.log('close');
    }
  
    function open_cart_details() {
    calcStone();
        $('.details_added_cart').removeClass('none');
        $('.details_added_cart').fadeIn(200);
        console.log('open');
    }
  
    function removeCartDetails(id, silent) {
      var j = 0;
      if ($(id).hasClass('removecart')) {
          j = $(id).attr('data-base');
          $(this).parent().remove();
      } else {
          j = $(id).attr('data-base');
      }
  
      objBracelet[j] = { 'id': j, 'price': 0, 'title': '', 'img': '' };

      $('#base_' + j).removeClass('stone_droped').css('background', 'rgba(206, 66, 124, 0.6313725490196078)').attr('data-title', '').attr('data-price', '');
    if (!silent) calcStone(true);
  }
  
    $( "#select_fontfamily" ).higooglefonts({     
        selectedCallback:function(e){
            console.log(e);
        },
        loadedCallback:function(font){
            console.log(font);
            /*/////// This is where you should apply font.///////
            /////////////////////////////////////////////////////*/       
            $("#own-page-stone-choice .stone_engrave_area .stone_engrave_text input").css("font-family", font); // Change the font-family of the #paragraph
        }     
    }); 
  
  
  
  
  
  